import { FaMicrophoneSlash } from "react-icons/fa";
import styled from "styled-components";
import NetworkQualityLevel from "../NetworkQualityLevel/NetworkQualityLevel";

const Wrapper = styled("div")`
  position: absolute;
  top: 0;
  left: 0;
  z-index: 5;
  display: flex;
  width: 100%;
  height: 35px;
  user-select: none;
`;

const InfoSection = styled("div")`
  display: flex;
  align-items: center;
  gap: 4px;
  min-width: 0;
  width: fit-content;
  max-width: 60%;
  height: fit-content;
  background-color: #14141496;
  color: #ffffff;
  padding: 3px 7px 4px 7px;
  border-radius: 0 0 10px 0;
`;

const Name = styled("span")`
  text-overflow: ellipsis;
  white-space: nowrap;
  overflow: hidden;
`;

const AudioOffIndicator = styled("div")`
  display: flex;
  align-items: center;
  justify-content: center;
  position: absolute;
  right: 5px;
  top: 5px;
  width: 20px;
  height: 20px;
  padding: 5px;
  border-radius: 50%;
  background-color: #14141496;
`;

interface IVideoInfoProps {
  name: string;
  videoType: "" | "local" | "remote" | "screen";
  isAudioOff: boolean;
}

const VideoInfo = ({ name, videoType, isAudioOff }: IVideoInfoProps) => {
  return (
    <Wrapper>
      <InfoSection>
        {/* Nome do usuário */}
        <Name>{name}</Name>

        {/* Indicativo qualidade da rede */}
        {videoType && videoType !== "screen" && (
          <NetworkQualityLevel participant={videoType} />
        )}
      </InfoSection>
      {/* Indicativo de microfone desabilitado */}
      {isAudioOff && (
        <AudioOffIndicator>
          <FaMicrophoneSlash size={18} fill="white" />
        </AudioOffIndicator>
      )}
    </Wrapper>
  );
};

export default VideoInfo;
